import { Input, InputProps } from 'antd';
import classNames from 'classnames';
import { forwardRef } from 'react';

import { Icon } from '@/shared/ui';

import { FormInput, FormInputProps } from '../FormInput/FormInput';

import type { InputRef } from 'antd/lib/input';

import { INPUT_MAX_LENGTH } from './constants';

import './TextInput.scss';

export type TextInputProps = FormInputProps & InputProps;

export const TextInput = forwardRef<InputRef, TextInputProps>(
  (
    {
      label,
      placeholder = 'Введіть дані',
      className,
      errorMessage,
      required,
      maxLength = INPUT_MAX_LENGTH,
      type = 'text',
      onChange,
      ...props
    },
    ref,
  ) => {
    return (
      <FormInput label={label} required={required} errorMessage={errorMessage}>
        <Input
          ref={ref}
          {...props}
          type={type}
          className={classNames('custom-text-input', className)}
          placeholder={placeholder}
          maxLength={maxLength}
          status={errorMessage ? 'error' : undefined}
          allowClear={{ clearIcon: <Icon name="close" color="grey" /> }}
          onChange={(e): void => {
            let value: string | number | undefined = e.target.value;

            if (type === 'number') {
              value = value === '' ? undefined : Number(value);
            }
            onChange?.({
              ...e,
              target: {
                ...e.target,
                // @ts-ignore
                value,
              },
            });
          }}
        />
      </FormInput>
    );
  },
);
